import "./Contact.scss";
import { useRef, useEffect, useState } from 'react';
import MailingListForm from "../components/MailingListForm";
import EmailAddress from "../components/EmailAddress";
import xLink from "../assets/xLink.svg"



function Contact() {
      // fade in
  const missionRef = useRef(null);
  const [isAtTop, setIsAtTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (missionRef.current) {
        const rect = missionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const fadeOutStartThreshold = viewportHeight * 0.10; // 20% of viewport height

        // Check if the top of the div has scrolled past the point where the fade should start
        setIsAtTop(rect.top <= fadeOutStartThreshold);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
    <div className="contact">
      <div 
        ref={missionRef}
        className={`contactContent ${isAtTop ? 'at-top' : ''}`}>
          <div className="centerTextContainer">
                <div className="centerText">Join our mailing list for updates on our robot building journey</div>
              <MailingListForm/>
            </div>
            <div className="centerTextContainer">
              <EmailAddress/>
                <div className="centerText2">
                    Are you operating a business in or working in a field with high rates of injury, or with significant downtime due to weather, conditions, or travel? Are you transporting and utilizing large, expensive equipment to do small to medium size jobs? We would love to hear about your challenges and work together on solutions to get your workers out of harms way. 
                </div>
            </div>
            <div className="textBox">
            <div className="headerText">
            Copyright © 2025 Satyress
            </div>
            <div className="headerText">
            <a
      href="https://x.com/satyressrobots"
      target="_blank" // Optional: Opens the link in a new tab/window
      rel="noopener noreferrer" // Security best practice when using target="_blank"
      className="socialLinkButton"
    >
               <img className="socialLink" src={xLink} alt="link to x.com profile"/>
               </a>
            </div>
            <div className="headerText">
                Satyress <i>(say-ter-ess)</i> Robotics - Auburn, California
            </div>
            </div>
      </div>
      </div>
    </>
  );
}

export default Contact;